var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"footer",attrs:{"app":"","height":"30"}},[_c('v-layout',{attrs:{"justify-center":"","row":"","wrap":""}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.copyrightText)}})]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","padding-right":"12px"}},[_vm._v("Version "+_vm._s(_vm.version))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a8d79390","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = null
// module chunks = 